import React from 'react';
import AdminRegistration from './AdminRegistration'
import { USER_ROLE } from '../../components/security/UserRole'

function HCPAdminRegistration(props) {
  

  return (
      <AdminRegistration userRole = {USER_ROLE.HCP_ADMIN} title={"HCP Admin Registration"}> </AdminRegistration>
  );
}


export default HCPAdminRegistration;
